module.exports = "../dist/img/white-21.0407.jpg";